/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * Boolean field representation.
 */
export interface BooleanClaimValue {
    /** The boolean field value. */
    value: boolean;
}
